import * as React from 'react';
// @ts-expect-error
import reactTooltip from 'react-tooltip';

import classnames from 'classnames';
import _ from 'underscore';

import type {EntityListType} from 'nutshell-core/types';

import {ColumnPickerButton as PickerButton} from 'shells/button/column-picker-button/column-picker-button';

import {ColumnPickerModal} from './column-picker-modal';

import styles from './column-picker-button.module.css';

export class ColumnPickerButton extends React.PureComponent<
    {
        entityType: EntityListType;
        schema: any;
        onResetFieldsToDefault: () => any;
        onUpdateFields: () => any;
        selectedColumns: string[];
    },
    {
        isOpen: boolean;
    }
> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isOpen: false,
        };
    }

    componentDidMount() {
        reactTooltip.rebuild();
    }

    render() {
        return (
            <div className={classnames('ui-column-picker__open', styles.container)}>
                {/* @ts-expect-error */}
                <PickerButton onClick={this.handleOpenColumnPicker} />
                <ColumnPickerModal
                    isOpen={this.state.isOpen}
                    entityType={this.props.entityType}
                    schemaProperties={_.values(this.props.schema)}
                    onResetFieldsToDefault={this.props.onResetFieldsToDefault}
                    onUpdateFields={this.props.onUpdateFields}
                    selectedColumns={this.props.selectedColumns}
                    onClose={this.handleCloseColumnPicker}
                />
            </div>
        );
    }

    handleOpenColumnPicker = () => {
        this.setState({isOpen: true});
    };

    handleCloseColumnPicker = () => {
        this.setState({isOpen: false});
    };
}
